import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { VisitResult } from '../../entities/control-tables/visit-result';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class VisitResultRequest extends BaseRequest {

    visitResult : VisitResult;

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.visitResult = new VisitResult()
  }
}